import { temAcesso } from '@/shared/auth/temAcesso'

const Requisicoes = () => import('./Requisicoes.vue')
const RequisicaoDetalhar = () => import('../../contratos/requisicoes/RequisicaoDetalhar')

export default {
    path: 'requisicoes',
    name: 'Gescon_Gestores_Requisicoes',
    component: Requisicoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-GEST-REQ-00')) {
            next()
        }
    },
    children: [
        {
            path: ':requisicaoId',
            name: 'Gescon_Gestores_Requisicoes_Detalhar',
            component: RequisicaoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-GEST-CONT-00')) {
                    next()
                }
            }
        }
    ]
}
